import {
  Button,
  Container,
  Flex,
  Box,
  Text,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Sidebar } from "./Sidebar";
import { Navigate, Routes, Route } from "react-router-dom";
import Events from "./Events";
import Admins from "./Admins";
import QRCodes from "./QRCodes";
import Settings from "./Settings";

import EventDetail from "./EventDetail";
import { CognitoUser } from "amazon-cognito-identity-js";
import { ModalType } from "../utils";
import FeedManager from "./FeedManager/FeedManager";

const EventManager = ({
  currentUser,
  setModalType,
}: {
  currentUser: CognitoUser | null;
  setModalType: (state: ModalType) => void;
}) => {
  const isDesktop = useBreakpointValue({ base: false, md: true });

  useEffect(() => {
    document.title = "Manager";
  }, []);
  return currentUser ? (
    <Flex
      as="section"
      direction={{ base: "column", md: "row" }}
      height="100vh"
      overflowY="auto"
    >
      {isDesktop ? (
        <Sidebar currentUser={currentUser} />
      ) : (
        <Navbar currentUser={currentUser} />
      )}

      <Box w="100%" overflowY="scroll">
        <Container maxW={"5xl"} py="8" px={4} flex="1">
          <Routes>
            <Route path="/settings" element={<Settings />} />
            <Route
              path="/bio"
              element={<FeedManager />}
            />
            <Route
              path="/links"
              element={<QRCodes currentUser={currentUser} />}
            />
            <Route
              path="/admins"
              element={<Admins currentUser={currentUser} />}
            />
            <Route path="/events" element={<Events />} />
            <Route
              path="/events/:event_id"
              element={<EventDetail setAppModalType={setModalType} />}
            />
            <Route path="*" element={<Navigate to={"/manager/events"} />} />
          </Routes>
        </Container>
      </Box>
    </Flex>
  ) : (
    <VStack h="100vh" justify={"center"}>
      <Text>Please sign in to access your dashboard</Text>
      <Button onClick={() => setModalType(ModalType.SIGN_IN_PHONE_NUMBER)}>
        Sign In
      </Button>
    </VStack>
  );
};

export default EventManager;
